<div class="cmn-flex row align-center gutters-sm banner-container" [ngClass]="{'cmn-border': showBorder, 'justify-center': center}">
  <mat-icon [ngClass]="{'big-icon': triggerButtonText}" class="custom-icon">report_gmailerrorred</mat-icon>
  <div>
    <div *ngIf="!message; else displayMessage">There are no {{resource}} to display.</div>
    <a *ngIf="triggerButtonText" href="javascript:void(0)" (click)="trigger.emit()">{{triggerButtonText}}</a>
  </div>
</div>

<ng-template #displayMessage>
  <div>{{message}}</div>
</ng-template>
